export default ({request}) => ({
  orderDocListApi(data = {}) {
    return request({
      url: '/factory/order/doc/list',
      method: 'post',
      data,
    })
  },
  orderDocDetailApi(data = {}) {
    return request({
      url: '/factory/order/doc/detail',
      method: 'post',
      data,
    })
  },
  orderDocBatchUploadApi(data = {}) {
    return request({
      url: '/factory/order/doc/batch/upload',
      method: 'post',
      data,
    })
  },
  orderDocBatchDelApi(data = {}) {
    return request({
      url: '/factory/order/doc/batch/del',
      method: 'post',
      data,
    })
  },
  orderDocUpdateApi(data = {}) {
    return request({
      url: '/factory/order/doc/update',
      method: 'post',
      data,
    })
  },
})
